import React from 'react'
import MyImage from '@shared/components/myImage'
import star from '@assets/images/Advertisement/star.png'
import styles from '@shared/components/Advertisement/Rating/Rating.module.scss'
const ratings = [
  {
    user: 'Shivani Pandey',
    review:
      'OneTurf News is perfect for sports fans, especially cricket! The live scores are accurate, and their special tournament coverage with insightful articles and interviews is unmatched. A must-have for cricket lovers!'
  },
  {
    user: 'Ansh Shukla',
    review:
      'OneTurf News is great for cricket and tennis. Accurate live scores, player stats, and top-notch tournament coverage make it a reliable app. Just wish match timings were more customizable! '
  },
  {
    user: 'Amiya Saha',
    review:
      'As a tennis fan, I love OneTurf News for live scores and Grand Slam coverage. Their match previews, post-match analysis, and in-depth cricket stats are excellent. Perfect for sports journalism! '
  },
  {
    user: 'Manik Roy',
    review:
      'OneTurf News is my go-to for cricket and tennis updates. Fast scores, expert opinions, and detailed tournament coverage make it stand out. A must for sports enthusiasts!'
  }
]

const Rating = () => {
  return (
    <>
      <section className={styles.sectionContainer}>
        <div className={styles.titleContainer}>
          <span className={styles.title}>Rating & Reviews</span>
        </div>

        <div className={styles.reviewsContainer}>
          {ratings.map((data, i) => (
            <div className={styles.card} key={i}>
              <div className={styles.cardInner}>
                <span className={styles.user}>{data.user}</span>
                <span className={styles.review}>{data.review}</span>
                <div className={styles.rating}>
                  <MyImage src={star} alt="Rating" />
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>
    </>
  )
}

export default Rating
